import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Box, Typography} from '@mui/material';

const SocialNetworkLink = ({imageUrl, link}) => {
    return (
        <Box
            sx={{
                marginLeft: '2px'
            }}
        >
            <a href={link}>
                <img
                    style={{maxWidth: '25px'}}
                    src={imageUrl}
                />
            </a>
        </Box>
    );
}

const FooterLogo = () => {
    return (
        <Box sx={{
            paddingTop: '20px',
            paddingBottom: '20px',
        }}>
            <img
                style={{maxWidth: '100px'}}
                src={require('../../images/logo/logo3.png')}
                alt={''}/>

            {/*<Box sx={{*/}
            {/*    display: 'flex',*/}
            {/*    justifyContent: 'center',*/}
            {/*    alignItems: 'center',*/}
            {/*}}>*/}
            {/*    /!*<SocialNetworkLink imageUrl={instagramLogo} link={'https://www.instagram.com/ar.endezvous?igsh=enNpOXJtbXBzenpl'}/>*!/*/}
            {/*    /!*<SocialNetworkLink imageUrl={facebookLogo}/>*!/*/}
            {/*    /!*<SocialNetworkLink imageUrl={whatsappLogo}/>*!/*/}
            {/*</Box>*/}

        </Box>
    );
}

export default FooterLogo;
